import { motion } from "framer-motion";

export function Overline({ children, className = "", color = "text-teal-400" }) {
  return (
    <div className={`font-mono text-[11px] uppercase tracking-[0.3em] ${color} ${className}`}>
      {children}
    </div>
  );
}

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Stat({ value, label, suffix = "" }) {
  return (
    <div className="border-l border-white/10 pl-5">
      <div className="font-display text-3xl md:text-4xl font-black text-white">
        {value}
        <span className="text-teal-400">{suffix}</span>
      </div>
      <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-1">{label}</div>
    </div>
  );
}
